import {connect} from "react-redux";
import LoginPage from "./LoginPage";
import * as authActions from "../actions/AuthActions";

function mapStateToProps(state) {
  return {

  }
}

export default connect(mapStateToProps, {...authActions})(LoginPage);